<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="650px">
        <v-card>
          <v-card-title>
            <span class="headline">添加白名单</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <form class="form">
                <!--begin::Body-->
                <div class="card-body p-1">
                  <div class="form-group row">
                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >IP白名单</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <input
                          ref="tax_id"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="IP地址"
                          v-model="form.ip_addr"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >白名单类型</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <v-select
                        v-model="form.type"
                        :items="typeItems"
                        item-text="memo"
                        item-value="code"
                        chips
                        persistent-hint
                      ></v-select>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label
                      class="col-xl-3 col-lg-3 col-form-label text-right pt-6"
                      >备注说明</label
                    >
                    <div class="col-lg-9 col-xl-6">
                      <div class="input-group input-group-lg input-group-solid">
                        <input
                          ref="memo"
                          type="text"
                          class="form-control form-control-lg form-control-solid"
                          placeholder="备注说明，可选项"
                          v-model="form.memo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!--end::Body-->
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white darken-1" @click="close">关闭</v-btn>
            <v-btn color="primary" dark @click="save">添加</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { postInstance } from "@/api/instance";
import { whiteListNums } from "@/api/whitelist";
import { mapGetters } from "vuex";
export default {
  name: "AddWhiteList",
  computed: {
    ...mapGetters(["currentUserBalance", "currentUser"]),
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      form: {
        type: "",
        ip_addr: "",
        memo: "",
      },
      typeItems: [],
      nums: {},
    };
  },
  created() {
    this.fetchWhiteListNums();
  },
  methods: {
    save() {
      postInstance("WHITELIST", this.form).then(() => {
        this.$parent.fetchWhiteList();
        this.$parent.fetchWhiteListNum();
        this.fetchWhiteListNums();
      });
    },
    close() {
      this.$emit("update:dialog", false);
      this.form = {
        type: "",
        ip_addr: "",
        memo: "",
      };
    },
    fetchWhiteListNums() {
      whiteListNums().then((res) => {
        this.nums = res.result;
        this.typeItems = [];
        this.typeItems.push({
          memo: "基础白名单" + " 可添加名额" + this.nums["base_num"] + "个",
          code: "base",
        });
        this.typeItems.push({
          memo: "额外白名单" + " 可添加名额" + this.nums["other_num"] + "个",
          code: "other",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-sale {
  position: absolute;
  top: -8px;
  right: 0;
  background-color: orange;
  color: #fff;
  font-size: 10px;
  height: 16px;
  padding: 1px 3px;
}
</style>
